import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import { Configure, Index } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import MenuButtonLabel from './components/MenuButtonLabel';
import SearchCount from './components/SearchCount';
import ProductSearchCount from './components/ProductSearchCount';
import buildSearchAlgoliaConfigureFilters from '../../buildSearchAlgoliaConfigureFilters';
const MobileSearchIndexSelector = () => {
  const $ = _c(53);
  const [expandableOpen, setExpandableOpen] = useState(false);
  const {
    currentSearchSection,
    updateSearchSection,
    isReadyToShipActive
  } = useAdvancedSearchContext();
  const getSectionTitle = _temp;
  const searchTitle = getSectionTitle(currentSearchSection);
  let t0;
  if ($[0] !== updateSearchSection) {
    t0 = indexName => {
      updateSearchSection(indexName);
      setExpandableOpen(false);
    };
    $[0] = updateSearchSection;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleIndexClick = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("md:hidden mobile-filters", {
      "mobile-filters--showTopBorder": true
    });
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] !== expandableOpen) {
    t2 = () => {
      setExpandableOpen(!expandableOpen);
    };
    t3 = classNames("flex-1 min-h-[3rem] space-x-1 flex items-center justify-center text-sm font-bold", {
      "mobile-filters__menu-expandable-button--open": expandableOpen
    });
    $[3] = expandableOpen;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== searchTitle) {
    t4 = <MenuButtonLabel title={searchTitle} />;
    $[6] = searchTitle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-center divide-x divide-gray-light7"><button type="button" onClick={t2} className={t3} aria-label="Toggle filters">{t4}</button></div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = !expandableOpen;
  let t7;
  if ($[12] !== expandableOpen || $[13] !== t6) {
    t7 = classNames("mobile-filters__expandable relative -top-px", {
      "mobile-filters__expandable--open border-b border-gray-light6": expandableOpen,
      hidden: t6
    });
    $[12] = expandableOpen;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["*"];
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isReadyToShipActive) {
    t9 = buildSearchAlgoliaConfigureFilters({
      isReadyToShipActive
    });
    $[16] = isReadyToShipActive;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = ["item_availability=0", "visibility>1", "visibility<4"];
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t9) {
    t11 = <Configure facets={t8} filters={t9} numericFilters={t10} getRankingInfo={true} />;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== currentSearchSection || $[22] !== handleIndexClick) {
    t12 = <ProductSearchCount title="Products" id={ALGOLIA_INDEX_NAME.PRODUCTS} selectedOption={currentSearchSection} indexClick={handleIndexClick} />;
    $[21] = currentSearchSection;
    $[22] = handleIndexClick;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <Index indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>{t11}{t12}</Index>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Index indexName={ALGOLIA_INDEX_NAME.CATEGORIES}><Configure filters="" numericFilters={["fk_store_id=1"]} facetFilters={["is_searchable:1"]} getRankingInfo={true} /></Index>;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = ["*"];
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Configure facets={t15} filters="" numericFilters="" facetFilters={[]} />;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== currentSearchSection || $[31] !== handleIndexClick) {
    t17 = <Index indexName="customer_photos">{t16}<SearchCount title="Customer Photos" id={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS} selectedOption={currentSearchSection} indexClick={handleIndexClick} /></Index>;
    $[30] = currentSearchSection;
    $[31] = handleIndexClick;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = ["*"];
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Configure facets={t18} filters="" numericFilters="" facetFilters={[]} />;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== currentSearchSection || $[36] !== handleIndexClick) {
    t20 = <Index indexName="reviews">{t19}<SearchCount title="Reviews" id={ALGOLIA_INDEX_NAME.REVIEWS} selectedOption={currentSearchSection} indexClick={handleIndexClick} /></Index>;
    $[35] = currentSearchSection;
    $[36] = handleIndexClick;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Configure filters="" numericFilters={["is_active=1", "show_in_search=1", "fk_store_id=1"]} />;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== currentSearchSection || $[40] !== handleIndexClick) {
    t22 = <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>{t21}<SearchCount title="Pages" id={ALGOLIA_INDEX_NAME.STATIC_PAGES} selectedOption={currentSearchSection} indexClick={handleIndexClick} /></Index>;
    $[39] = currentSearchSection;
    $[40] = handleIndexClick;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t13 || $[43] !== t17 || $[44] !== t20 || $[45] !== t22) {
    t23 = <div className="text-base text-gray font-normal">{t13}{t14}{t17}{t20}{t22}</div>;
    $[42] = t13;
    $[43] = t17;
    $[44] = t20;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t23 || $[48] !== t7) {
    t24 = <div className={t7}>{t23}</div>;
    $[47] = t23;
    $[48] = t7;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t24 || $[51] !== t5) {
    t25 = <div className={t1}>{t5}{t24}</div>;
    $[50] = t24;
    $[51] = t5;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  return t25;
};
export default MobileSearchIndexSelector;
function _temp(section) {
  switch (section) {
    case ALGOLIA_INDEX_NAME.PRODUCTS:
      {
        return "Products";
      }
    case ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS:
      {
        return "Customer Photos";
      }
    case ALGOLIA_INDEX_NAME.REVIEWS:
      {
        return "Reviews";
      }
    case ALGOLIA_INDEX_NAME.STATIC_PAGES:
      {
        return "Pages";
      }
    default:
      {
        return "Products";
      }
  }
}